import { render, staticRenderFns } from "./management-library-legal-document-template-form.vue?vue&type=template&id=09aa3c1e"
import script from "./management-library-legal-document-template-form.vue?vue&type=script&lang=js"
export * from "./management-library-legal-document-template-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports